/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const locationSearchFilterSchema = z.object({
  activeOnly: z.boolean().nullish(),
  countryCodes: z.array(z.string()).nullish(),
  holidaySchemeIds: z.array(z.int()).nullish(),
  subdivisions: z
    .array(z.string())
    .describe(
      'Subdivisions to match, each qualified by its country, for example US:CA. The value 0 matches locations with no subdivision set.',
    )
    .nullish(),
});
